import React, {useCallback} from 'react';
import {useTranslation} from 'react-i18next';
import EditorLayout from '../../../../components/Layouts/EditorLayout';
import SMCTextInput from '../../../../components/Simple/SMCTextInput';
import {ServerGetSchema} from '../../../../api/DBSchema/Server';
import Sepperator from '../../../../components/Simple/Sepperator';
import SMCLabel from '../../../../components/Simple/SMCLabel';
import {SMCCheckbox} from '../../../../components/Simple/SMCCheckbox';

const pageSchema = ServerGetSchema.pages.settings;
const pageId = pageSchema.pageId;

function ServerSettings({
    serverObject,
    setServerData
}) {
    const { t } = useTranslation();

    const pageData = serverObject[pageId];
    const setPageValue = useCallback((paramName, value) => {
        setServerData([pageId, paramName], value);
    }, [setServerData]);


    const description      = pageData[pageSchema.description];
    const dnsEnabled       = pageData[pageSchema.dnsEnabled];
    const dnsAddress       = pageData[pageSchema.dnsAddress];
    const smpServerAddress = pageData[pageSchema.smpServerAddress];
    const smpNatAddress    = pageData[pageSchema.smpNatAddress];
    const serverDnsName    = pageData[pageSchema.serverDnsName];
    const isActive         = pageData[pageSchema.isActive];

    return (
        <EditorLayout lineHeight="24px">
            <SMCLabel bold>{t('SMP.SMP_SERVERS.PAGE.GENERAL_SETTINGS')}</SMCLabel>
            <SMCTextInput
                value={description}
                onChange={e => setPageValue(pageSchema.description, e.target.value)}
                label={t('SMP.DESCRIPTION')}
            />
            <SMCCheckbox
                labelPosition="start"
                checked={dnsEnabled}
                onChange={e => setPageValue(pageSchema.dnsEnabled, e.target.checked)}
                label={t('SMP.SMP_SERVERS.PAGE.ENABLE_DNS_SERVICE')}
            />
            <SMCTextInput
                value={dnsAddress}
                onChange={e => setPageValue(pageSchema.dnsAddress, e.target.value)}
                label={t('SMP.SMP_SERVERS.PAGE.DNS_LISTING_ADDRESS')}
            />
            <Sepperator />
            <SMCLabel bold>{t('SMP.SMP_SERVERS.PAGE.SERVER_IP_ADDRESS')}</SMCLabel>
            <SMCTextInput
                value={smpServerAddress}
                onChange={e => setPageValue(pageSchema.smpServerAddress, e.target.value)}
                label={t('SMP.SMP_SERVERS.PAGE.IP_ADDRESS')}
            />
            <SMCTextInput
                value={smpNatAddress}
                onChange={e => setPageValue(pageSchema.smpNatAddress, e.target.value)}
                label={t('SMP.SMP_SERVERS.PAGE.NAT_IP_ADDRESS_EX_IP')}
                tooltip={t('SMP.SMP_SERVERS.PAGE.NAT_IP_ADDRESS_EX_IP.TOOLTIP')}
            />
            <SMCTextInput
                value={serverDnsName}
                onChange={e => setPageValue(pageSchema.serverDnsName, e.target.value)}
                label={t('SMP.SMP_SERVERS.PAGE.DNS_NAME')}
                tooltip={t('SMP.SMP_SERVERS.PAGE.DNS_NAME.TOOLTIP')}
            />
            <Sepperator />
            <SMCLabel bold>{t('SMP.SMP_SERVERS.PAGE.LOAD_BALANCING')}</SMCLabel>
            <SMCCheckbox
                labelPosition="start"
                checked={isActive}
                onChange={e => setPageValue(pageSchema.isActive, e.target.checked)}
                label={t('SMP.SMP_SERVERS.PAGE.IS_ACTIVE')}
            />
        </EditorLayout>
    )
}

export default ServerSettings;